import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nobility',
  templateUrl: './nobility.component.html',
  styleUrls: ['./nobility.component.scss']
})
export class NobilityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
